import { FC, useCallback, MouseEvent } from 'react';
import { Link } from 'react-router';
import { RouterConfig } from '@edikk-edikk/shared';
import GirlStub from '@edikk-edikk/country-common/images/girl-stub.webp';
import { AdvertPictureForPhoto } from '@edikk-edikk/country-layout-black';
import { useAdvertCardContext } from '#advert/components/card';
import advertCardPhotoCss from '../../assets/advert-card-photo.module.scss';

const Photo: FC = () => {
  const {
    showBottomSheet,
    advert,
    isAllowBottomSheet,
  } = useAdvertCardContext();

  const handlerClick = useCallback((e: MouseEvent<HTMLAnchorElement>) => {
    if (!isAllowBottomSheet) {
      return;
    }

    e.preventDefault();
    showBottomSheet();
  }, [isAllowBottomSheet, showBottomSheet]);

  return (
    <Link
      to={advert.url}
      state={{ routerConfig: RouterConfig.initForAdvertDetail(advert.id) }}
      className={advertCardPhotoCss.advertCardPhoto}
      onClick={handlerClick}
    >
      <AdvertPictureForPhoto
        photo={advert.photo}
        stub={GirlStub}
        className={advertCardPhotoCss.advertCardPhoto__image}
        isAllowAltFromPhoto
        width={200}
        height={240}
        fetchPriority="high"
      />
    </Link>
  );
};

export { Photo };
